module.exports = __webpack_public_path__ + "static/img/frame_vtlh.9d4ab96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame_vtlh.png
// module id = B/bQ
// module chunks = 1